
import Vue from "vue";

import CartPopover from "./CartPopover.vue";
import CartIcon from "./CartIcon.vue";

export default Vue.extend({
  name: "NavigationCartButton",
  components: {
    CartIcon,
    CartPopover,
  },
  computed: {
    positionCount(): number {
      return this.$store.getters["cart/getCount"]();
    },
  },
  methods: {
    click(e: MouseEvent) {
      const mqString = "(max-width: 575.98px)";
      const mediaQueryList = window.matchMedia(mqString);
      const isMobile = mediaQueryList.matches;
      if (isMobile) {
        e.stopPropagation();
        this.$router.push("/checkout/");
      }
    },
  },
});
